export const kwpBadges = {
  start: {
    id: "start",
    class: "status",
    type: "start",
    label: "S",
    key: "NOTIFICATION_SERVICE.EDIT.KWP.STATUS_CHANGE"
  }
};
